(() => {
  if (window.__textSeparatorCleanerLoaded) return;
  window.__textSeparatorCleanerLoaded = true;

  const NBSP_REGEX = /\u00A0/g;
  const PIPE_REGEX = /\|/g;

  const normalizeSpaces = (value) => (value || '').replace(NBSP_REGEX, ' ');
  const WHITESPACE_REGEX = /\s/g;

  const isSeparatorTextNode = (node) => {
    if (!node || node.nodeType !== Node.TEXT_NODE) return false;
    const raw = normalizeSpaces(node.nodeValue);
    return raw.includes('|') && raw.replace(WHITESPACE_REGEX, '') === '|';
  };

  const nodeHasRenderableValue = (node) => {
    if (!node) return false;

    if (node.nodeType === Node.TEXT_NODE) {
      const text = normalizeSpaces(node.nodeValue).trim();
      return text !== '' && text !== '|';
    }

    const text = normalizeSpaces(node.textContent).replace(PIPE_REGEX, '').trim();
    return text !== '';
  };

  const keepSingleSeparator = (nodes, value) => {
    if (nodes.length === 0) return;

    const [firstNode, ...otherNodes] = nodes;
    firstNode.nodeValue = value;

    for (const node of otherNodes) {
      node.remove();
    }
  };

  const cleanParagraph = (paragraph) => {
    const children = Array.from(paragraph.childNodes);
    const pendingSeparators = [];
    let hasSeenRenderable = false;

    for (const child of children) {
      if (isSeparatorTextNode(child)) {
        pendingSeparators.push(child);
        continue;
      }

      if (!nodeHasRenderableValue(child)) continue;

      if (!hasSeenRenderable) {
        keepSingleSeparator(pendingSeparators, '| ');
      } else {
        keepSingleSeparator(pendingSeparators, ' | ');
      }

      pendingSeparators.length = 0;
      hasSeenRenderable = true;
    }

    for (const separator of pendingSeparators) {
      separator.remove();
    }

    const paragraphTextWithoutPipes = normalizeSpaces(paragraph.textContent).replace(PIPE_REGEX, '').trim();
    if (paragraphTextWithoutPipes === '') {
      paragraph.remove();
    }
  };

  const cleanTextBlock = (textBlock) => {
    const scope = textBlock.querySelector('.see-more__content') || textBlock;
    const paragraphs = scope.querySelectorAll('p');

    for (const paragraph of paragraphs) {
      cleanParagraph(paragraph);
    }
  };

  const runCleaner = () => {
    const textBlocks = document.querySelectorAll('[data-clean-separators="true"]');

    for (const textBlock of textBlocks) {
      cleanTextBlock(textBlock);
    }
  };

  window.__runTextSeparatorCleaner = runCleaner;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runCleaner, { once: true });
  } else {
    runCleaner();
  }

  document.addEventListener('shopify:section:load', runCleaner);
  document.addEventListener('shopify:section:select', runCleaner);
})();
